document.addEventListener('wpcf7mailsent', function(event) {
    const form = event.target;
    const formContainer = form.closest('.wpcf7');
    const responseOutput = formContainer.querySelector('.wpcf7-response-output');

    if (form && responseOutput) {
        formContainer.querySelectorAll('.wpcf7-form > *:not(.wpcf7-response-output)').forEach(element => {
          element.setAttribute('style', 'display: none !important;');  
        });

        const offset = 200;
        const top = form.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({
            top: top,
            behavior: 'smooth'
        });
    }
  }, false);
